import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import {
  getLayoutColorPrimaryForNav,
  mergeAntdThemeForNavMode,
} from '../../../config/antdThemeByMode';
import {
  type LayoutSettingsWithToken,
  mergeProLayoutToken,
} from '../../../config/proLayoutThemeByMode';
import { useAntdConfigSetter, useIntl, useModel } from '@umijs/max';
import { Button, Tooltip } from 'antd';
import React from 'react';
import {
  NAV_THEME_STORAGE_KEY,
  syncNavThemeHtmlClass,
} from '@/utils/navThemeHtmlClass';

const ThemeToggle: React.FC = () => {
  const intl = useIntl();
  const { initialState, setInitialState } = useModel('@@initialState');
  const setAntdConfig = useAntdConfigSetter();
  const navTheme = initialState?.settings?.navTheme;
  const isDark = navTheme === 'realDark';
  const toggleLabel = intl.formatMessage({
    id: isDark
      ? 'component.globalHeader.theme.switchToLight'
      : 'component.globalHeader.theme.switchToDark',
  });

  const toggle = () => {
    const nextDark = !isDark;
    const nextNav = nextDark ? 'realDark' : 'light';
    try {
      localStorage.setItem(NAV_THEME_STORAGE_KEY, nextNav);
    } catch {
      // ignore
    }
    setAntdConfig((prev) => ({
      ...prev,
      theme: mergeAntdThemeForNavMode(
        prev.theme,
        nextDark ? 'realDark' : 'light',
      ),
    }));
    const navMode = nextDark ? 'realDark' : 'light';
    setInitialState((pre) => ({
      ...pre,
      settings: {
        ...(pre?.settings as LayoutSettingsWithToken | undefined),
        navTheme: nextNav,
        colorPrimary: getLayoutColorPrimaryForNav(navMode),
        token: mergeProLayoutToken(
          (pre?.settings as LayoutSettingsWithToken | undefined)?.token,
          navMode,
        ),
      },
    }));
    syncNavThemeHtmlClass(navMode);
  };

  return (
    <Tooltip title={toggleLabel}>
      <Button
        type="text"
        aria-label={toggleLabel}
        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
        onClick={toggle}
        style={{
          display: 'inline-flex',
          padding: 4,
          fontSize: 18,
          color: 'inherit',
        }}
      />
    </Tooltip>
  );
};

export default ThemeToggle;
